export default {
      id: "ic_tribun-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun-usage",
      toString: function () {
        return this.url;
      }
    }